import React from 'react';
import { Size } from 're-resizable';

import { IconButton, Icons } from 'widget/components';
import { useIsPrimaryDark } from 'widget/hooks';
import { useResize } from '../../hooks';

interface Restore {
  updateSize: (value: Size) => void;
}

const Restore = ({ updateSize }: Restore) => {
  const isPrimaryDark = useIsPrimaryDark();
  const { defaultSize } = useResize();

  return (
    <IconButton size={24} onClick={() => updateSize(defaultSize)}>
      <Icons.FrameCornersSimple
        fill={isPrimaryDark ? 'white' : 'dark'}
        size={20}
      />
    </IconButton>
  );
};

export default Restore;
